import { Vue } from 'vue-class-component';
import { Inject, Watch } from 'vue-property-decorator';
import type { VueI18n } from 'vue-i18n';
import { ReserveVehicleModuleContext } from '@/store/reserve-vehicle';
import { WriteupModuleContext } from '@/store/writeup';
import { Icon, IconNames } from '@/components/icon';
import { Routes } from '@/router/routes';
import { Button, ButtonTypes } from '@/components/button';
import { AMPLITUDE_LABELS } from '@/common/constants';
import { CoreModuleContext } from '@/store/core';
import styles from './styles.module.scss';

export class ReserveVehicleWidget extends Vue {
	async created() {
		this.reserveVehicleModule.mutations.unsetDisplayWidget();

		if (this.writeupId && this.vehicleVin) {
			this.checkReservedVehicleRequest = `?writeupId=${this.writeupId}&vin=${this.vehicleVin}`;
			const response = await this.reserveVehicleModule.actions.checkReservedVehicle(this.checkReservedVehicleRequest);
		}
	}

	@Inject() readonly i18n!: VueI18n;

	@Inject() readonly coreModule!: CoreModuleContext;

	@Inject() readonly reserveVehicleModule!: ReserveVehicleModuleContext;

	@Inject() readonly writeupModule!: WriteupModuleContext;

	get isReserveVehicle() { return this.reserveVehicleModule ? this.reserveVehicleModule.getters.isReservedVehicle : undefined; }

	get displayWidget() { return this.reserveVehicleModule ? this.reserveVehicleModule.getters.isDisplayWidget : undefined; }

	get timeLimit() { return this.reserveVehicleModule ? this.reserveVehicleModule.getters.reserveTimeLimit : 0; }

	get depositAmount() { return this.reserveVehicleModule ? this.reserveVehicleModule.getters.depositAmount : 0; }

	get vehicleVin() { return this.writeupModule ? this.writeupModule.getters.vehicleVin : undefined; }

	get writeupId() { return this.writeupModule ? this.writeupModule.getters.writeupObject?.writeupId : undefined; }

	handleClose() {
		this.reserveVehicleModule.mutations.unsetDisplayWidget();
	}

	@Watch('vehicleVin')
	@Watch('writeupId')
	async updateWidget() {
		this.reserveVehicleModule.mutations.unsetDisplayWidget();
		this.checkReservedVehicleRequest = `?writeupId=${this.writeupId}&vin=${this.vehicleVin}`;
		const response = await this.reserveVehicleModule.actions.checkReservedVehicle(this.checkReservedVehicleRequest);
	}

	checkReservedVehicleRequest = '';

	triggerEvent() {
		const eventData = {
			Label: AMPLITUDE_LABELS.customizeDeal,
			Action: 'ReserveAVehicle',
			...this.$route.meta,
		};

		this.coreModule.actions.sendEvent(eventData);
	}

	render() {
		return (
			<div class={ styles.reserveVehicleWidgetContainer } v-show={ this.displayWidget }>
				<div class={ styles.reserveVehicleWidgetContainerText } v-show={ !this.isReserveVehicle }>
					<Button
						class={ styles.reserveVehicleWidgetContainerLink }
						to={ Routes.RESERVE_VEHICLE_OVERVIEW.path }
						type={ ButtonTypes.link }
						inverted
						inline
						onClick={ this.triggerEvent }
					>
						{ this.i18n.t('reserveVehicleWidget.linkText') }
					</Button>
					{ this.i18n.t('reserveVehicleWidget.header', { amount: this.depositAmount }) }
				</div>
				<div class={ styles.reserveVehicleWidgetContainerText } v-show={ this.isReserveVehicle }>
					{ this.i18n.t('reservedVehicleWidget.header') }
					<Button
						class={ styles.reserveVehicleWidgetContainerLink }
						to={ Routes.RESERVED_VEHICLE_INFO.path }
						type={ ButtonTypes.link }
						inverted
						inline
					>
						{ this.i18n.t('reservedVehicleWidget.linkText') }
					</Button>
				</div>
				<div class={ styles.reserveVehicleWidgetContainerCloseIcon }>
					<Button
						type={ ButtonTypes.link }
						inverted
						onClick={ this.handleClose }
						v-slots={ { icon: () => <Icon name={ IconNames.close } size={ 20 } /> } }
					>
					</Button>
				</div>
			</div>
		);
	}
}
